import { Row, Col } from 'react-bootstrap';
import dayjs from 'dayjs';

const UserTile = ({userUnlockReward}) => {
    return (
        <Row className="user-tile">
            <Col className="col-12">
                <p className='m-0 fw-bold text-capitalize'>{userUnlockReward.user.username}</p>
            </Col>
            <Col className="col-12">
                <p className='m-0'>{userUnlockReward.user.email}</p>
            </Col>
            <Col className="col-12">
                <p className='m-0' >{dayjs(userUnlockReward.createdAt).format('DD MMM YYYY, HH:mm')}</p>
            </Col>
        </Row>
    
    )
}   

export default UserTile;